import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { RESOLVE_SYSTEM_TASK_ITEM } from "./graphql";
import JsonText from "./JsonText";
import { formatDate } from "./utils";

const SystemTaskItemsTable = ({ items, onResolved }) => {
  const [resolveItem, { loading: resolving }] = useMutation(
    RESOLVE_SYSTEM_TASK_ITEM,
    {
      onCompleted: () => {
        Alert("success", "Item resolved.");
        onResolved?.();
      },
    },
  );

  if (!items?.length) {
    return <div className="text-xs opacity-60">No items.</div>;
  }

  return (
    <div className="overflow-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left border-b border-gray-100 dark:border-gray-700">
            <th className="py-2">Title</th>
            <th className="py-2">Status</th>
            <th className="py-2">Object</th>
            <th className="py-2">Detected</th>
            <th className="py-2">Resolved</th>
            <th className="py-2">Data</th>
            <th className="py-2 text-right">Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr
              key={item.id}
              className="border-b border-gray-100 dark:border-gray-700"
            >
              <td className="py-2">{item.title || "-"}</td>
              <td className="py-2">{item.status || "-"}</td>
              <td className="py-2">
                {item.objectType || "-"} #{item.objectId || "-"}
              </td>
              <td className="py-2">{formatDate(item.detectedAt)}</td>
              <td className="py-2">{formatDate(item.resolvedAt)}</td>
              <td className="py-2 max-w-xs">
                <JsonText value={item.data} />
              </td>
              <td className="px-3 py-2 text-right">
                {item.status === "OPEN" ? (
                  <Button
                    disabled={resolving}
                    onClick={() => {
                      if (!window.confirm("Confirm resolve this item?")) return;
                      resolveItem({
                        variables: { id: item.id },
                      });
                    }}
                  >
                    Resolve
                  </Button>
                ) : (
                  <span className="opacity-60">-</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SystemTaskItemsTable;
